export default __webpack_public_path__ + "static/media/icon2.18850ca8.png";